import { schema } from 'normalizr';

export const orderSchema = new schema.Entity('orders', {}, { idAttribute: 'OrderId' });

export const orderListSchema = [orderSchema];

export const orderMissingDocumentListSchema = new schema.Entity('orderMissingDocumentLists', {}, { idAttribute: 'OrderId' });
